import { DefaultError, UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { useDucatClient } from '@/context/DucatClientCtx';

import { QueryKeys } from '../query-keys';

import { quantaApi } from './quantaApi';

export interface QuantaCheckResponse {
  data: {
    isRegistered: boolean;
  };
}

type QueryOptionsParam = Omit<UseQueryOptions<QuantaCheckResponse, DefaultError>, 'queryKey' | 'queryFn'>;

export const useQuantaCheck = (options?: QueryOptionsParam): UseQueryResult<QuantaCheckResponse, Error> => {
  const { pubkey } = useDucatClient();

  return useQuery({
    queryKey: [QueryKeys.quantaCheck, pubkey],
    queryFn: async () => {
      const result = await quantaApi.get('/check', {
        headers: {
          'x-user-public-key': pubkey,
        },
      });

      return result.data;
    },
    staleTime: Infinity,
    retry: false,
    enabled: !!pubkey,
    ...options,
  });
};
